import {ModifyMenuDataAddon} from '../../../types/product.type';
import {createStore, withProps} from '@ngneat/elf';

export interface ModifyMenuDataState {
  modifyMenuData: ModifyMenuDataAddon;
  modifyMenuDataUpdated: ModifyMenuDataAddon;
}

export function createInitialModifyMenuDataState(): ModifyMenuDataState {
  return {
    modifyMenuData: initDefaultModifyMenuData(),
    modifyMenuDataUpdated: initDefaultModifyMenuData(),
  };
}

function initDefaultModifyMenuData(): ModifyMenuDataAddon {
  return {
    color_mode: null,
    dictionary: false,
    features_pattern: null,
    oversized: false,
    profiles: false,
    two_columns_layout: true,
    id: null,
    is_enabled: false,
    is_renewable: false,
    user_service_id: null,
  };
}

export const addonStore = createStore(
  {name: 'addon'},
  withProps<ModifyMenuDataState>(createInitialModifyMenuDataState()),
);
